import {
  CustomButton,
  CustomForm,
  CustomFormItem,
  CustomImage,
  CustomModal,
  CustomSelect,
  Option,
  successDialog,
  Text,
  useText,
} from '@src/components';
import modalClose from '@src/assets/icons/icon-close.svg';
import React, { useCallback } from 'react';
import '@src/styles/manageMyCards/deliveryAddressModal.scss';
import { Form } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { cardGetPagedList, employeesUpdateAddressList } from '@src/store/slice/manageMyCardsSlice';
import { VouIdCode } from '@src/store/enums';

const DeliveryAddressUpdateModal = ({
  modalVisible,
  handleModalVisible,
  isCompliments = false,
  isMarket = false,
}) => {
  const [form] = Form.useForm();
  const { selectedCards, filterObject } = useSelector((state) => state?.manageMyCards);
  const { addressPagedList } = useSelector((state) => state?.address);
  const dispatch = useDispatch();
  let vouId;

  if (isMarket) {
    vouId = VouIdCode.Market;
  } else if (isCompliments) {
    vouId = VouIdCode.Compliments;
  } else {
    vouId = VouIdCode.Restaurant;
  }
  const yourTransactionHasBeenSuccessfullyCompleted = useText('yourTransactionHasBeenSuccessfullyCompleted');
  const updateDeliveryAddress = useText('updateDeliveryAddress');
  const handleClose = useCallback(() => {
    handleModalVisible(false);
    form.resetFields();
  }, [form, handleModalVisible]);

  const handleApprove = useCallback(async () => {
    try {
      const values = await form.validateFields();
      let requestDtos = selectedCards.map((card) => {
        return {
          addressId: values?.addressId,
          personalCode: card?.personalCode,
          isAddressUpdate: true,
        };
      });
      if (isCompliments || isMarket) {
        requestDtos.vouId = vouId;
      }
      const action = await dispatch(employeesUpdateAddressList({ requestDtos: requestDtos }));
      if (employeesUpdateAddressList.fulfilled.match(action)) {
        successDialog({
          title: <Text t="successfullySent" />,
          message: action?.payload?.message || yourTransactionHasBeenSuccessfullyCompleted,
          onOk: async () => {
            handleClose();
            await dispatch(cardGetPagedList({ body: { vouId: vouId }, ...filterObject }));
          },
        });
      }
    } catch (e) { }
  }, [dispatch, filterObject, form, handleClose, selectedCards]);

  return (
    <CustomModal
      className="delivery-address-update-modal"
      maskClosable={false}
      footer={false}
      title={updateDeliveryAddress}
      visible={modalVisible}
      onCancel={handleClose}
      closeIcon={<CustomImage src={modalClose} />}
    >
      <div className="download-container">
        <CustomForm
          name="deliveryAddressUpdateForm"
          className="delivery-address-update-form"
          initialValues={{}}
          autoComplete="off"
          layout={'horizontal'}
          form={form}
        >
          <CustomFormItem
            label={
              <div>
                <Text t="newDeliveryAddress" />
                <span>:</span>
              </div>
            }
            name="addressId"
            className="delivery-address-form-item"
          >
            <CustomSelect
              id="ticketRestaurant-manageMyCards-deliveryAddressUpdateModal-addressId-select"
              placeholder={useText('selectAddress')}
              height={36}
            >
              {addressPagedList.map((x) => (
                <Option
                  id={`ticketRestaurant-manageMyCards-deliveryAddressUpdateModal-addressId-${x?.addressName}-option`}
                  key={x?.id}
                  value={x?.id}
                >
                  {x?.addressName}
                </Option>
              ))}
            </CustomSelect>
          </CustomFormItem>
        </CustomForm>

        <p className="info-text">
          <Text t="numberOfCardsWhoseAddressWillChange" /> <span>{selectedCards.length || 0}</span>
        </p>

        <div className="footer-btn">
          <CustomButton
            id="ticketRestaurant-manageMyCards-deliveryAddressUpdateModal-download-btn"
            className="download-btn"
            onClick={handleApprove}
          >
            <Text t="approve2" />
          </CustomButton>
          <CustomButton
            id="ticketRestaurant-manageMyCards-deliveryAddressUpdateModal-cancel-btn"
            className="cancel-btn"
            onClick={handleClose}
          >
            <Text t="giveUp" />
          </CustomButton>
        </div>
      </div>
    </CustomModal>
  );
};
DeliveryAddressUpdateModal.propTypes = {
  modalVisible: PropTypes.any,
  handleModalVisible: PropTypes.any,
  isCompliments: PropTypes.bool,
  isMarket: PropTypes.bool,
};
export default DeliveryAddressUpdateModal;
